import React from 'react'
import {
  Action,
  Actions,
  Detail,
  Details,
  TitleGroup,
  Price,
  Text,
  Location,
  InfoArea,
  Favorite,
  SeeInstallmentTestABCard
} from '@/modern/components/Card'
import MegaFeiraoStamp from '@/modern/components/Stamps/MegaFeirao'
import BlackFeiraoStamp from '@/modern/components/Stamps/BlackFeirao'
import OfertaDestaqueStamp from '@/modern/components/Stamps/OfertaDestaque'
import ParceiroSantanderStamp from '@/modern/components/Stamps/ParceiroSantander'
import AutopagoStamp from '@/modern/components/Stamps/Autopago'
import CarDeliveryExtendedStamp from '@/modern/components/Stamps/ExtendedCarDelivery'
import useFavorites from '@/modern/actions/useFavorites'
import { config } from 'config/config'
import {
  Link,
  LinkWithGrow,
  AlignHeaderStamp,
  LineContainer,
  StampsContainer,
  FavoriteContainer,
  DetailContainer,
  InfoContainer,
  PriceContainer,
  Division
} from '../style'

const Separator = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="4"
      viewBox="0 0 4 4"
      fill="none"
    >
      <circle cx="2" cy="2" r="2" fill="#AEAEBA" />
    </svg>
  )
}

const InfoAreaVertical = ({
  id,
  model,
  make,
  version,
  price,
  year,
  travelledDistance,
  location,
  href = '#',
  hasFavoriteActions = false,
  stamps = {},
  canIUseParceiroSantander,
  wasFavorited = false,
  wasSold = false,
  type,
  oldAd = null,
  color = '',
}) => {
  const { checkIfCardWasFavorited, setFavoriteItem } = useFavorites()
  const linkProps = !wasSold ? { rel: 'nofollow', target: '_blank', href } : {}
  const cardWasFavoritedInStore = checkIfCardWasFavorited(id)
  const { showCarDeliveryExtendedStamp } = config

  const hasStamp =
    stamps.autopago ||
    stamps.feiroes.blackFeirao ||
    stamps.feiroes.megaFeirao ||
    stamps.feiroes.ofertaDestaque ||
    canIUseParceiroSantander() ||
    (stamps.carDelivery && showCarDeliveryExtendedStamp)

  return (
    <InfoArea>
      <LineContainer>
        {hasStamp && (
          <StampsContainer>
            {stamps.autopago && (
              <AlignHeaderStamp>
                <AutopagoStamp />
              </AlignHeaderStamp>
            )}

            {stamps.feiroes.blackFeirao && (
              <AlignHeaderStamp>
                <BlackFeiraoStamp />
              </AlignHeaderStamp>
            )}

            {stamps.feiroes.megaFeirao && (
              <AlignHeaderStamp>
                <MegaFeiraoStamp />
              </AlignHeaderStamp>
            )}

            {stamps.feiroes.ofertaDestaque && (
              <AlignHeaderStamp>
                <OfertaDestaqueStamp />
              </AlignHeaderStamp>
            )}

            {canIUseParceiroSantander() && (
              <AlignHeaderStamp>
                <ParceiroSantanderStamp />
              </AlignHeaderStamp>
            )}

            {stamps.carDelivery && showCarDeliveryExtendedStamp && (
              <AlignHeaderStamp>
                <CarDeliveryExtendedStamp id={id} />
              </AlignHeaderStamp>
            )}
          </StampsContainer>
        )}

        <FavoriteContainer>
          <Favorite
            id={id}
            onClick={() =>
              setFavoriteItem({
                id,
                type,
                wasFavorited: cardWasFavoritedInStore,
                oldAd,
                details: { ...oldAd, Type: type },
              })
            }
            filled={wasFavorited || cardWasFavoritedInStore}
          />
        </FavoriteContainer>
      </LineContainer>

      <LinkWithGrow {...linkProps}>
        <InfoContainer>
          <TitleGroup
            needsRightSpace={stamps.superPreco}
            title={`${make} ${model}`}
            subtitle={version}
          />

          <Details>
            <Detail>
              <DetailContainer>
                <Text value={year} /> <Separator />{' '}
                <Text value={travelledDistance} /> <Separator />
                <Text value={color} />
              </DetailContainer>
            </Detail>
          </Details>
        </InfoContainer>
      </LinkWithGrow>

      <Link {...linkProps}>
        <PriceContainer>
          <Price value={price} />
        </PriceContainer>
        <SeeInstallmentTestABCard link={linkProps.href} />
      </Link>

      <Division />

      <Details minHeight="31px">
        <Detail>
          <Link {...linkProps}>
            <Location value={location} />
          </Link>
        </Detail>
      </Details>

      {hasFavoriteActions && (
        <Actions>
          <Action
            onClick={() =>
              setFavoriteItem({
                id,
                type,
                wasFavorited: cardWasFavoritedInStore,
                oldAd,
                details: oldAd,
              })
            }
            value="Remover"
          />
        </Actions>
      )}
    </InfoArea>
  )
}

export default InfoAreaVertical
